<template>
  <main class="quality-zone container">
    <div class="bannerBox">
      <van-image class="banner" :src="youpPath + bannerImg" />
      <div class="modify">
        <div class="subCon"></div>
      </div>
    </div>
    <div class="tipBox">
      <div class="tipItem">
        <span class="iconfont icon-dui-copy"></span>
        <span>精选好物</span>
      </div>
      <div class="tipItem">
        <span class="iconfont icon-dui-copy"></span>
        <span>9.9包邮</span>
      </div>
      <div class="tipItem">
        <span class="iconfont icon-dui-copy"></span>
        <span>高性价比</span>
      </div>
    </div>
    <souhuo-list :data-list="dataList" :scroll-disabled="scrollDisabled" @loadMore="loadMore" @entoDetailPage="entoDetailPage" :show-head="false" :need-item-margin-top="true"> </souhuo-list>
    <!-- no more -->
    <segement-line v-if="!haveMore" line-text="没有更多商品啦"> </segement-line>
    <!-- loading -->
    <segement-line v-if="haveMore" line-text="正在加载" :is-load="true"> </segement-line>
    <!-- 返回顶部 -->
    <quick-top @returnTop="returnTop" :isReturn="isReturn" :positionBtm="20"></quick-top>
  </main>
</template>

<script>
import { IMG_BASE_URL } from '@/config'
import souhuoList from '@/components/puppetComponent/SouhuoList'
import SegementLine from '@/components/puppetComponent/SegementLine'
import QuickTop from '@/components/smartComponent/QuickTop'
import { onePackage, noLoginOnePackage } from '@/api/onePackage'
import { mapGetters } from 'vuex'
import { Indicator, Toast } from 'mint-ui'
export default {
  data() {
    return {
      dataList: [],
      haveMore: true,
      scrollDisabled: false,
      pageScrollTop: 0,
      youpPath: IMG_BASE_URL,
      bannerImg: '/upaiyun/Sys/20211028/5666905901570998963.png',
      // 获取数据接口，是否为最后一条
      isLastOne: false,
      isReturn: false
    }
  },
  components: {
    souhuoList,
    SegementLine,
    QuickTop
  },
  computed: {
    ...mapGetters(['loginState'])
  },
  mounted() {
    // this.fetchData()
    // 绑定监听事件
    this.$nextTick(() => {
      this.container = document.getElementsByClassName('container')[0]
      this.container.addEventListener('scroll', this.handleScroll)
    })
  },
  methods: {
    reFetchPage(from) {
      if (from.name === 'goodsDetail' && this.container) {
        this.$nextTick(() => {
          this.container.scrollTop = this.pageScrollTop
        })
      } else {
        this.dataList = []
        this.dataList.splice(0)
        this.pageScrollTop = 0
        this.isReturn = false
        this.isLastOne = false
        this.fetchData()
      }
    },
    fetchData(isDropDown = false) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = {
        DropDown: isDropDown,
        SortType: 1,
        Amount: 9.9
      }
      this.scrollDisabled = true
      if (this.loginState) {
        onePackage(params)
          .then((res) => {
            this.handleSuccessResult(res)
          })
          .catch((res) => {
            this.haveMore = false
            Indicator.close()
            if (res.ErrMsg) {
              Toast(res.ErrMsg)
            }
          })
      } else {
        noLoginOnePackage(params)
          .then((res) => {
            this.handleSuccessResult(res)
          })
          .catch((res) => {
            this.haveMore = false
            Indicator.close()
            if (res.ErrMsg) {
              Toast(res.ErrMsg)
            }
          })
      }
    },
    handleSuccessResult(res) {
      this.dataList = [...this.dataList, ...res.DataList]
      this.isLastOne = res.BoolSID
      if (res.BoolSID) {
        this.haveMore = false
      } else {
        this.haveMore = true
      }
      this.scrollDisabled = false
      Indicator.close()
    },
    loadMore() {
      if (this.isLastOne) {
        this.haveMore = false
        return
      }
      this.haveMore = true
      this.fetchData(true)
    },
    // 进入详情页
    entoDetailPage(productID, isStockNoZero, isFreeCard) {
      this.$router.push({
        name: 'goodsDetail',
        query: {
          productID: productID,
          isFreeCard: isFreeCard
        }
      })
    },
    // 返回顶部
    returnTop: function() {
      let container = this.container
      container.scrollTop = 0
    },
    // 滚动监听
    handleScroll(e) {
      // 滚动高度
      let scrollTop = this.container.scrollTop
      this.pageScrollTop = scrollTop
      // 屏幕高度
      let documentH = document.documentElement.clientHeight || document.body.clientHeight
      if (scrollTop > documentH) {
        this.isReturn = true
      } else {
        this.isReturn = false
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.reFetchPage(from)
    })
  }
}
</script>

<style scoped="scoped" lang="scss">
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.quality-zone {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  // background-color: #f5f5f5;
  .bannerBox {
    position: relative;
    overflow: hidden;
    .banner {
      width: 100%;
      display: block;
    }
    .modify {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: vw(1200);
      height: vw(900);
      transform: translateX(-50%);
      background-color: #fff;
      .subCon {
        width: 100%;
        height: 100%;
        background: url('http://youp-read.leqilucky.com/upaiyun/Sys/20211028/5666905901570998963.png') no-repeat;
        background-size: vw(375) auto;
        background-position-y: bottom;
        background-position-x: center;
        border-radius: 80%;
      }
    }
  }
  .tipBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: vw(12);
    font-weight: 400;
    color: #666666;
    height: vw(40);
    border-bottom: 1px solid rgba(242, 242, 242, 0.8);
    background-color: #fff;
    padding: 0 2%;
    .tipItem {
      display: flex;
      align-items: center;
      .iconfont {
        color: #f05c61;
        margin-right: vw(4);
      }
    }
  }
}
@media screen and (max-width: 320px) {
  .banner {
    height: 7rem;
  }
}
</style>
